const DEFAULT_DELIVERY_ZIP = 'na';
const DEFAULT_BD_WHS = 'na';
const DEFAULT_STORE_LOCATION = { storeLocation: { city: 'na' } };

export const getLocalWarehouseFromCookies = (
    cookies: any,
    { isBD }: { isBD?: boolean } = {},
) => {
    const {
        invCheckPostalCode: BCdeliveryZip = DEFAULT_DELIVERY_ZIP,
        STORELOCATION: BCstoreLocation = DEFAULT_STORE_LOCATION,
        WC_BD_ZIP: BDDeliveryZip = DEFAULT_DELIVERY_ZIP,
        WC_BD_WHS: BDStoreLocation = DEFAULT_BD_WHS,
    } = cookies;

    let deliveryZip = BCdeliveryZip;
    let localWH = BCstoreLocation?.storeLocation?.city;

    if (isBD) {
        deliveryZip = BDDeliveryZip;
        localWH = BDStoreLocation
            ? `${BDStoreLocation}`.split('|')?.[0]
            : DEFAULT_BD_WHS;
    }

    return { deliveryZip, localWH };
};

export function getCookie(cookieName: string): string {
    try {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        if (typeof ca === 'undefined') {
            return '';
        }
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i] as string;
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    } catch (e) {
        return '';
    }
}
